import { render } from "./LookForwardTotals.vue?vue&type=template&id=6b073c51"
import script from "./LookForwardTotals.vue?vue&type=script&lang=js"
export * from "./LookForwardTotals.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__